<template>
  <div align="center">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-2)">{{ $t("inquiry") }} </a>
      <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-1)">  
        <span v-if="AwbBlType=='S'">  {{ $t("sea") }} </span> 
        <span v-if="AwbBlType=='A'"> {{ $t("air") }}</span>  </a>
      <img src="../../assets/img/jt.gif" />{{ $t("normal_po_title") }}
    </div>
     <div>
<table width="98%" cellpadding="0" cellspacing="0" >
  	<tr><td width="20%" align="left"><b> {{ $t("anonymou_house_no") }}:</b> &nbsp;{{info.house_No}}</td>
  	<td width="13%" align="left"><b>{{ $t("anonymou_orgn_code") }}:</b> &nbsp;{{info.orgn_Code}}</td>
  	 <td width="13%" align="left"><b> {{ $t("anonymou_dest_code") }}:</b> &nbsp; {{info.dest_Code}}</td>
  	 <td width="13%" align="left"><b> {{ $t("anonymou_qty") }}:</b> &nbsp;{{info.qty}}</td>
  	 <td width="13%" align="left"><b>  {{ $t("anonymou_gw") }}:</b> &nbsp;{{info.gw}}</td>
  	 <td width="13%" align="left"><b> {{ $t("anonymou_vw") }}:</b> &nbsp;{{info.cbm}}</td>
  	 <td width="15%"></td>
    </tr>
  </table>  
     </div>
   
     <table-no-record v-if="JSON.stringify(TgInvpoList)=='[]'"></table-no-record>
   <div>
           <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe" v-if="JSON.stringify(TgInvpoList)!='[]'">
      <!--DWLayoutTable-->
    <tbody>
    <tr class="trtitle">
      <td width="15%" height="20" valign="middle">{{ $t("normal_po_inv") }}</td>
      <td width="15%">{{ $t("normal_po_no") }}</td>
	  <td width="15%"> {{ $t("normal_po_part") }}</td>
	  <td width="10%">{{ $t("pkg") }}</td>
	  <td width="10%"> {{ $t("gw") }}</td>
	  <td width="35%"> {{ $t("normal_po_remark") }}</td>
    </tr>
  
	<!-- <bean:define id="temp" type="Tg_invpo" name="object"/> -->
	<!-- <c:if test="${i%2!=0}">
	  <tr class="tr1" onmouseover="this.className='shen'" onmouseout="this.className='tr1'">
    </c:if>
    <c:if test="${i%2==0}">
	  <tr class="tr2" onmouseover="this.className='shen'" onmouseout="this.className='tr2'">
    </c:if> -->
    <tr v-for="(item,index) in TgInvpoList" :key="index" >
      <td height="18" valign="middle"> {{item.invNo}} </td>
      <td valign="middle"> {{item.poNo}} </td>
      <td valign="middle"> {{item.partNo}}</td>
      <td valign="middle"> {{item.qty}} &nbsp; {{item.qtyUnit}} </td>
      <td valign="middle"> {{item.gw}} &nbsp; {{item.gwUnit}}</td>
      <td valign="middle">{{item.remark}}</td>
    </tr>
    <!-- <c:set var="i" value="${i+1}"/> -->
 
    </tbody>
  </table>
   </div>
   
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import { GetTgInvpo } from "@/api/branchBillOflading.js";
export default {
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
  }, 
  data() {
    return {
      HouseNo: "",
      info:{

      },
      TgInvpoList:[],
      lang:'',
      AwbBlType:''
    }
  },
  async mounted() {
     var model = JSON.parse(this.$route.query.info);
     this.info=model.item;
    this.AwbBlType=this.$route.query.AwbBlType;
       //this.lang = this.$store.getters.lang;
       //console.log(this.lang)
    // console.log(this.info);
    // console.log(this.$route.query.HouseNo);
      var self = this;
    await GetTgInvpo({ HouseNo: this.info.house_No }).then((res) => {
      if (res.code == 200) {
        self.TgInvpoList = res.data==null?[]:res.data;
      }
    });
  }
  
    
}
</script>
<style lang="less">

</style>